import { useTranslation } from "react-i18next";
import { SOURCE_PDF_FILENAME, SOURCE_PDF_HREF } from "@/pages/SourceReportPage";
import { HubPageTitle } from "../components/HubPageTitle";

/**
 * Hub view for the downloadable source report (PDF).
 * Nav links here; download is explicit via the button.
 */
export function HubReportPage() {
  const { t } = useTranslation();

  return (
    <div className="nbs-hub-page" data-testid="hub-rapport-page">
      <section className="nbs-hub-section">
        <HubPageTitle>{t("hub.reports.title")}</HubPageTitle>

        <article className="nbs-hub-card nbs-hub-rapport">
          <header className="nbs-hub-card__head">
            <h3>{t("hub.reports.cardTitle")}</h3>
            <p>{t("hub.reports.cardLead")}</p>
          </header>

          <dl className="nbs-hub-rapport__meta">
            <div>
              <dt>{t("hub.reports.fileName")}</dt>
              <dd>
                <code>{SOURCE_PDF_FILENAME}</code>
              </dd>
            </div>
            <div>
              <dt>{t("hub.reports.pages")}</dt>
              <dd>160</dd>
            </div>
            <div>
              <dt>{t("hub.reports.format")}</dt>
              <dd>PDF</dd>
            </div>
          </dl>

          <p className="nbs-hub-muted">{t("hub.reports.description")}</p>

          <div className="nbs-hub-reports__actions">
            <a
              className="nbs-hub-btn"
              href={SOURCE_PDF_HREF}
              download={SOURCE_PDF_FILENAME}
              data-testid="hub-rapport-download"
            >
              {t("hub.reports.download")}
            </a>
            <a
              className="nbs-hub-btn nbs-hub-btn--ghost"
              href={SOURCE_PDF_HREF}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hub-rapport-open"
            >
              {t("hub.reports.open")}
            </a>
          </div>
        </article>
      </section>
    </div>
  );
}
